const baseJson = () => {
  return {
    name: null,
    sort: 0,
    content: null,
    menu: null,
    publicationDate: null,
    isPublish: false,
    describe: null,
    fileImage: null,
    nameAuthor: null,
    publicationDateShow: null,
    createdAtShow: null,
    createdAt: null
  };
};
const toJson = (item) => {
  if (!item) return baseJson();

  return {
    _id: item._id,
    name: item.name,
    sort: item.sort,
    content: item.content,
    describe: item.describe,
    isPublish: item.isPublish,
    publicationDate: item.publicationDate,
    menu: item.menu,
    nameAuthor: item.nameAuthor,
    createdAtShow: item.createdAtShow,
createdAt: item.createdAt,
    fileImage: item.fileImage
      ? {
          fileId: item.fileImage.fileId,
          fileName: item.fileImage.fileName,
          ext: item.fileImage.ext,
          path: item.fileImage.path,
        }
      : null,
  };
};
const fromJson = (item) => {
  if (!item) return baseJson();
  return {
    _id: item._id,
    name: item.name,
    content: item.content,
    menu: item.menu,
    publicationDate: item.publicationDate,
    publicationDateShow: item.publicationDateShow,
    isPublish: item.isPublish,
    describe: item.describe,
    sort: item.sort,
    fileImage: item.fileImage || null,
    nameAuthor: item.nameAuthor,
    createdAtShow: item.createdAtShow,
    createdAt: item.createdAt
  };
};

export const tinTucModel = {
  baseJson,
  fromJson,
  toJson,
};
